import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Filter } from 'src/app/routes/search-cars-component/car-filter.helper';

@Component ({
    selector: 'app-multiselect-filter',
    templateUrl: './multiselect-filter.component.html',
    styleUrls: [ './multiselect-filter.component.scss' ],
})

export class MultiSelectFilterComponent implements OnInit {
    @Input() label = '';
    @Input() styleClass: string = '';
    @Input() filter: Filter = {
        field: '',
        title: '',
        open: false,
        values: [],
        displayAs: 'checkbox',
    };

    @Input() selected: any[] = [];

    @Output() selectionEmmiter: EventEmitter<any> = new EventEmitter();

    allStyleClass = '';
    placeholder = 'Select';
    
    constructor () {}

    ngOnInit() {
        this.allStyleClass = `${this.styleClass} trm-filter-location`;
        this.placeholder = `Select ${this.label}`;
    }
    
    emitContents(event: any): void {
        let allIndex = this.filter.values.findIndex((x) => x.name === 'All');
        if (allIndex != -1) {
            let all = this.filter.values[allIndex];
            let selectedCountryNames = this.selected.map(x => x.name);
            if (event.itemValue.name === all.name) {
                this.selected = selectedCountryNames.includes(all.name)?
                this.filter.values: [];
            } else {
                selectedCountryNames.push(all.name);
                this.selected = this.filter.values.every(x => selectedCountryNames.includes(x.name))?
                this.filter.values: this.selected.filter(x => x.name !== all.name);
            }
        }
        this.selectionEmmiter.emit({ filter: this.filter, selected: this.selected });
    }
}
